<template>
  <div class="header">
    <el-header :class="['headerTop', pageScrollTop !== 0 ? 'navBg' : '']">
      <img class="headerTopImg1" src="../assets/header/logo_1.png">
      <div class="headerTopqie">
        <div class="websiteIconBtn1" @click="els_web_siteClick">
          <el-button type="primary" class="elButt"> {{ $store.state.navShow == true ? 'Cn' : 'En' }} </el-button>
        </div>
        <div class="headerTopDiv" @click="menuShow = true">
          <img class="headerTopImg2" v-if="pageScrollTop == 0" src="../assets/header/menu.png">
          <img class="headerTopImg2" v-if="pageScrollTop !== 0" src="../assets/header/menu2.png">
        </div>
      </div>
    </el-header>
    <el-drawer size="85%" :withHeader="false" :visible.sync="menuShow" direction="rtl">
      <header id="el-drawer__title" class="el-drawer__header">
        <img src="../assets/header/menuLogo.png">
        <button aria-label="close drawer" type="button" class="el-drawer__close-btn" @click="menuShow = false">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </button>
      </header>
      <div class="drawerCon">
        <!-- v-if="item.hidden" -->
        <div class="drawerConTitle1" v-for="(item, index) in navList" :key="index">
          <div class="drawerConTitle3" v-if="item.hidden">
            <el-collapse class="wai" v-model="activeName" accordion>
              <el-collapse-item class="waiCon" :title="$store.state.navShow == true ? item.name : item.EnName" name="1"
                style=" width: 100%;">
                <div v-for="(item1, index1) in item.children" :key="index1">
                  <div v-if="item1.hidden">
                    <el-collapse class="nei" v-model="activeName1" accordion>
                      <el-collapse-item class="neiCon" :class="sizeColor"
                        :title="$store.state.navShow == true ? item1.name : item1.EnName" :name="index1">
                        <div class="neiConLink">
                          <div class="" v-for="(item2, index2) in item1.children" :key="index2">
                            <div class="" style="display: flex; ">
                              <router-link :class="sizeColor" @click="menuShow = false" :to="item2.path"
                                style="font-size: 0.875rem;font-family: Microsoft YaHei;font-weight: 500;color: #666666;text-decoration: none;">
                                {{ $store.state.navShow == true ? item2.name : item2.EnName }} </router-link>
                              <div
                                style="font-size: 0.875rem;font-family: Microsoft YaHei;font-weight: 500;color: #666666; margin: 0 0.4rem; "
                                v-if="item2.meta.ioco"> {{ item2.meta.ioco }} </div>
                            </div>
                          </div>
                        </div>
                      </el-collapse-item>
                    </el-collapse>
                  </div>
                  <div class="drawerConTitle2" style="width: 95%; margin-left: 5%;" v-else>
                    <router-link :class="sizeColor" @click="menuShow = false" :to="item1.path"
                      style="font-size: 0.875rem;font-family: Microsoft YaHei;font-weight: 400;color: #666666;text-decoration: none; width: 100%; text-align: left;">
                      {{ $store.state.navShow == true ? item1.name : item1.EnName }} </router-link>
                  </div>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
          <div class="drawerConTitle2" v-else>
            <router-link :class="sizeColor" @click="menuShow = false" :to="item.path"
              style="color: #111; text-decoration:none; width: 100%; text-align: left;">{{ $store.state.navShow == true ?
								item.name : item.EnName }} </router-link>
          </div>
        </div>
        <div class="RussiaWeb" @click="els_web_siteClick(elsWeb)" style="display:none;">
          <img class="RussiaWebImg" src="../assets/header/Russia.png">
          <div class="RussiaWebText"> 俄罗斯官网 </div>
        </div>
        <div class="websiteIconBtn" @click="els_web_siteClick">
          <el-button type="primary" class="elButt"> {{ $store.state.navShow == true ? 'Cn' : 'En' }} </el-button>
        </div>
      </div>
    </el-drawer>
    <el-carousel class="headerBanner" @change="business" :height="bannerHeight + 'px'" :autoplay="autoplay"
      v-if="typeHeader == 'indexHeader'" arrow="always" :initial-index='lbtIs_show'>
      <el-carousel-item v-for="(item, index) in $store.state.navShow == true ? bannerList : bannerListE" :key="index">
        <img :src="item.img" @click="bannerClickUrl(item.id, item.url)">
      </el-carousel-item>
    </el-carousel>
    <!-- 其他页面展示头部图片展示 -->
    <div class="noIndexPageImg " :style="{ height: bannerHeight + 'px' }" v-else-if="typeHeader == 'defaultHeader'">
      <div class="noIndexShow">
        <!-- banner -->
        <slot name="headerImage"></slot>
        <!-- <img src="https://pic.imgdb.cn/item/615407e22ab3f51d910fde2c.jpg" alt=""> -->
        <div class="black_div">
          <!-- 标题 -->
          <!-- <h1>Margin Group 全球客户得忠实伙伴</h1> -->
          <span data-aos="fade-up">
            <slot name="headerTitle"></slot>
          </span>
        </div>
      </div>
    </div>
    <div class="bannerCons" v-if="typeHeader == 'indexHeader'">
      <el-carousel :autoplay="false" arrow="never" indicator-position="none" :initial-index='lbtIs_show' ref="squareLbt"
        :style="'height:' + bannerConsheight + 'px;'">
        <el-carousel-item>
          <div class="showCon">
            <div class="showConTop">
              <el-row type="flex" justify="space-between" class="showConTopImg" :gutter="10">
                <el-col :span="6"
                  v-for="(item, index) in $store.state.navShow == true ? showConImgList.list0.top : showConImgListE.list0.top"
                  :key="index">
                  <img :src="item.img" @click="JupmPath(item.path)">
                </el-col>
              </el-row>
            </div>
            <div class="showConbBtton">
              <el-row type="flex" class="showConTopImg" :gutter="20">
                <el-col :span="15">
                  <img class="showConBttonImg_1"
                    :src="$store.state.navShow == true ? showConImgList.list0.img5.img : showConImgListE.list0.img5.img"
                    @click="JupmPath($store.state.navShow == true ? showConImgList.list0.img5.path : showConImgListE.list0.img5.path)">
                </el-col>
                <el-col :span="15">
                  <img class="showConBttonImg_2"
                    :src="$store.state.navShow == true ? showConImgList.list0.img6.img : showConImgListE.list0.img6.img"
                    @click="JupmPath($store.state.navShow == true ? showConImgList.list0.img6.path : showConImgListE.list0.img6.path)">
                </el-col>
                <!-- 			<el-col :span="10">
									<img class="showConBttonImg_3" :src="showConImgList.list0.img7.img"
										@click="JupmPath(showConImgList.list0.img7.path)">
								</el-col> -->
              </el-row>
            </div>
          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="showCon_2">
            <div class="showCon2Top">
              <div class="showCon2TopImg"
                v-for="(item, index) in $store.state.navShow == true ? showConImgList.list3 : showConImgListE.list3"
                :key="index">
                <img :src="item.img" @click="JupmOtherPath(item.id)">
              </div>
            </div>
          </div>
        </el-carousel-item>
        <!-- <el-carousel-item>
					<div class="showCon_2">
						<div class="showCon2Top">
							<div class="showCon2TopImg" v-for="(item, index) in $store.state.navShow == true ? showConImgList.list1 : showConImgListE.list1" :key="index">
								<img :src="item.img" @click="JupmOtherPath(item.id)">
							</div>
						</div>
					</div>
				</el-carousel-item> -->
        <el-carousel-item>
          <div class="showCon_3">
            <div class="showCon3Top">
              <div class="showCon3TopImg"
                v-for="(item, index) in $store.state.navShow == true ? showConImgList.list2 : showConImgListE.list2"
                :key="index">
                <img :src="item.img">
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        bannerConsheight: 185,
        activeName: '0',
        activeName1: '0',
        bannerHeight: this.$route.meta.bannerHeight, // 轮播图高度
        bannerIndex: 0,
        businessShow1: true,
        businessShow2: false,
        businessShow3: false,
        lbtIs_show: 0, //控制首页轮播图 以及 对应的按钮 展示的第几个
        bannerList: [{
            img: require("@/assets/header/Banner1.jpg"),
            id: 1,
            url: ''
          },
          {
            img: require("@/assets/header/Banner2-1.jpg"),
            id: 2,
            url: '/CR_overseasServiceProvider'
          },
          // {
          // 	img: require("@/assets/header/Banner2.jpg"),
          // 	id: 3,
          // 	url: ''
          // },
          {
            img: require("@/assets/header/Banner3.jpg"),
            id: 4,
            url: ''
          }
        ],
        bannerListE: [{
            img: require("@/assets/header/Banner1_E.jpg"),
            id: 1,
            url: ''
          },
          {
            img: require("@/assets/header/Banner2-1_E.jpg"),
            id: 2,
            url: '/CR_overseasServiceProvider'
          },
          // {
          // 	img: require("@/assets/header/Banner2_E.jpg"),
          // 	id: 3,
          // 	url: ''
          // },
          {
            img: require("@/assets/header/Banner3_E.jpg"),
            id: 4,
            url: ''
          }
        ],
        // ---
        showConImgList: {
          list0: {
            top: [{
                img: require("@/assets/header/business1.png"),
                title: '海运服务',
                path: '/CR_oceanShipping'
              },
              {
                img: require("@/assets/header/business2.png"),
                title: '汽车运输',
                path: '/CR_automobileTransportation'
              },
              {
                img: require("@/assets/header/business3.png"),
                title: '空运服务',
                path: '/CR_airServices'
              },
              // {
              // 	img: require("@/assets/header/business4.png"),
              // 	title: '中俄清关',
              // 	path: '/CR_customsClearance'
              // },
              {
                img: require("@/assets/header/business15.png"),
                title: '境外承运',
                path: '/CR_overseasTransportation'
              },
            ],
            img5: {
              img: require("@/assets/header/business5.png"),
              title: '中欧运输',
              path: '/chinaEuropeTrain'
            },
            img6: {
              img: require("@/assets/header/business6-1.png"),
              title: '国际贸易',
              path: '/internationalTrade'
            },

          },
          list1: [{
              img: require("@/assets/header/business8.png"),
              id: 1,
            },
            // {
            // 	img: require("@/assets/header/business9.png"),
            // 	id: 2,
            // },
            {
              img: require("@/assets/header/business10.png"),
              id: 3,
            },
            {
              img: require("@/assets/header/business111.png"),
              id: 4,
            },
          ],
          list2: [{
              img: require("@/assets/header/business12.png"),
            },
            {
              img: require("@/assets/header/business13.png"),
            },
            {
              img: require("@/assets/header/business14.png"),
            },
          ],
          list3: [],
        },

        showConImgListE: {
          list0: {
            top: [{
                img: require("@/assets/header/business1_E.png"),
                title: '海运服务',
                path: '/CR_oceanShipping'
              },
              {
                img: require("@/assets/header/business2_E.png"),
                title: '汽车运输',
                path: '/CR_automobileTransportation'
              },
              {
                img: require("@/assets/header/business3_E.png"),
                title: '空运服务',
                path: '/CR_airServices'
              },
              // {
              // 	img: require("@/assets/header/business4_E.png"),
              // 	title: '中俄清关',
              // 	path: '/CR_customsClearance'
              // },
              {
                img: require("@/assets/header/business15_E.png"),
                title: '境外承运',
                path: ''
              },
            ],
            img5: {
              img: require("@/assets/header/business5_E.png"),
              title: '中欧运输',
              path: '/chinaEuropeTrain'
            },
            img6: {
              img: require("@/assets/header/business6-1_E.png"),
              title: '国际贸易',
              path: '/internationalTrade'
            },

          },
          list1: [{
              img: require("@/assets/header/business8_E.png"),
              id: 1,
            },
            // {
            // 	img: require("@/assets/header/business9_E.png"),
            // 	id: 2,
            // },
            {
              img: require("@/assets/header/business10_E.png"),
              id: 3,
            },
            {
              img: require("@/assets/header/business111.png"),
              id: 4,
            },
          ],
          list2: [{
              img: require("@/assets/header/business12_E.png"),
            },
            {
              img: require("@/assets/header/business13_E.png"),
            },
            {
              img: require("@/assets/header/business14_E.png"),
            },
          ],
          list3: [],
        },
        autoplay: false,
        menuShow: false,
        false1: false,
        navList: [],
        bannerConsSaver: false,
        pageScrollTop: window.pageYOffset,
        sizeColor: '',
        elsWeb: '',
      };

    },
    props: {
      // 是否是首页类型展示
      typeHeader: {
        type: String,
        default: 'defaultHeader'
      },
      // 新闻页面 和 非首页页面的不同header高度
      typeHeight: {
        type: String,
        default: '480' //  480
      },
      pageType: {
        type: String,
        default: 'otherPages'
      },
      // 接收新闻中心详情传过来的新闻标题
      newsTitleRoute: {
        type: String,
        default: ''
      },
      // 是否是新闻中心的route标题
      routeIsNews: {
        type: Boolean,
        default: false
      }
    },

    mounted() {
      this.sizeColor = this.$route.meta.sizeColor;
      this.bannerHeight = this.bannerHeight / 2;
      // 获取到导航List
      this.navList = this.$router.options.routes[0].children;
      //隐藏不显示内容
      this.bannerConsSaver = this.$route.meta.bannerConsSaver;
      // 监听页面向下滚动的距离
      window.addEventListener('scroll', e => {
        // console.log("e", window.pageYOffset)
        this.pageScrollTop = window.pageYOffset
      }, true) // 监听滚动事件

      /**
       * 首页，关于我们，货运追踪 seo
       * 罗锦炜
       * 2021-12-07
       */
      if (this.$route.meta.seo === 'defaultSeo') {
        // 调用接口地址
        this.$axios.get(this.$route.meta.seoRequestUrl).then(res => {
          // console.log('seo',res.data.data);
          if (res.data.code === 1) {
            // 调用更新页面的seo函数
            this.updateSeoFun(res.data.data)
          } else {
            this.$message({
              showClose: true,
              message: this.$route.name + 'seo,' + res.data.msg,
              type: 'error'
            })
          }
        })
      }

      /**
       * 俄罗斯官网 接口
       * 罗锦炜
       * 2021-12-08
       */
      this.$axios.get('/api/Index/footer').then(res => {
        console.log('底部数据=>', res)
        if (res.data.code === 1) {
          // 俄罗斯官网
          this.elsWeb = res.data.data.footerConfig.els_web_site
        } else {
          // 可关闭得提醒
          this.$message({
            showClose: true,
            message: '俄罗斯官网' + res.data.msg,
            type: 'error'
          })
        }
      })

      /**
       * 联系我们seo
       * 罗锦炜
       * 2021-12-07
       */
      if (this.$route.meta.seo === 'contactUsSeo') {
        this.$axios.get('/api/Contactus/index').then(result => {
          // console.log('联系我们seo11111111111111',result)
          if (result.data.code === 1) {
            // 调用更新页面的seo函数
            this.updateSeoFun(result.data.data.seo)
          } else {
            this.$message({
              showClose: true,
              message: this.$route.name + 'seo,' + result.data.msg,
              type: 'error'
            })
          }
        })
      }

      /**
       * 我们的服务 seo
       * 罗锦炜
       * 2021-12-07
       */
      if (this.$route.meta.seo === 'serveSeo') {
        this.$axios.get('/api/Ourservices/index', {
          params: {
            catid: this.$route.meta.seoId // 栏目id
          }
        }).then(res => {
          // console.log('我们服务',res)
          if (res.data.code === 1) {
            // 调用更新页面的seo函数
            this.updateSeoFun(res.data.data)
          } else {
            this.$message({
              showClose: true,
              message: this.$route.name + 'seo,' + res.data.msg,
              type: 'error'
            })
          }
        })
      }
    },
    methods: {
      /**
       * 俄罗斯官网
       * 罗锦炜
       * 2021-12-08
       */
      // els_web_siteClick(url) {
      // 	console.log(url);
      // 	// window.location.href = this.elsWeb; // 不打开新的窗口
      // 	// window.open(url) // 打开新的窗口
      // 	// window.location.href = this.elsWeb
      // 	// window.location.href = 'http://www.Baidu.com';
      // },
      els_web_siteClick() {
        this.$store.state.navShow = !this.$store.state.navShow
        // console.log(this.$children.abcde())
        // this.$children
        console.log(this)
        // console.log(this.$parent.abcde());
        //  this.$parent.abcde();
        //  this.$emit('abcde')
        // this.abcde();
        // window.open(this.elsWeb, '_blank')
      },

      /**
       * 切换轮播图及内容
       * 罗锦炜
       * 2021-12-1
       */
      business(id) {
        console.log(id)
        this.lbtIs_show = Number(id);
        // console.log('this.lbtIs_show',this.lbtIs_show)
        this.$refs.squareLbt.setActiveItem(id);
        // if (id == 1) {
        // 	this.bannerConsheight = 40
        // }
        // this.bannerIndex = id;
        if (id == 0) {
          this.bannerConsheight = 180
        } else if (id == 1) {
          this.bannerConsheight = 0
        } else if (id == 2) {
          this.bannerConsheight = 100
        }
        // else if (id == 3) {
        // 	this.bannerConsheight = 100
        // }
      },

      /**
       * 更新页面的seo函数
       * 罗锦炜
       * 2021-12-07
       */
      updateSeoFun(options) {
        // 标题
        document.title = options.title
        // 获取到所有的meta标签 (在public文件夹中的 index.html中 一般新建项目是没有关键字和描述的 需要自己手动填写)
        const AllMeta = document.getElementsByTagName('meta')

        for (var i = 0; i < AllMeta.length; i++) {
          // keywords
          if (AllMeta[i].getAttribute('name') === 'keywords') {
            AllMeta[i].content = options.keywords
          }
          // description
          if (AllMeta[i].getAttribute('name') === 'description') {
            AllMeta[i].content = options.description
          }
        }
      },
      /**
       * 打开菜单
       * 罗锦炜
       * 2021-12-1
       */
      drawer() {
        this.menuShow = !this.menuShow;
        console.log('11s');
        console.log(this.menuShow);
      },
      /**
       * 菜单内选项事件
       * 罗锦炜
       * 2021-12-1
       */
      handleChange(val) {
        console.log(val);
      },
      /**
       * 导航菜单跳转
       * 罗锦炜
       * 2021-12-1
       */
      jumpUrlFun(path) {
        // 接收不同传过来的参数
        console.log('path=>', path)
        this.$router.push(path)
        this.menuShow = false;
      },
      /**
       * 跳转
       * 罗锦炜
       * 2021-12-08
       * */
      JupmPath(path) {
        console.log(this.$router.history.current.fullPath);
        if (path == this.$router.history.current.fullPath) {
          document.documentElement.scrollTop = 0
        } else {
          this.$router.push({
            path: path,
            // query: {
            // 	newId: newId
            // }
          })
        }

      },

      /**
       * @param {Object} id
       * 轮播图跳转
       * 罗锦炜
       * 2022-1-10
       */
      bannerClickUrl(id, url) {
        if (url != '') {
          this.$router.push({
            path: url,
          })
        } else {
          return;
        }
      },
      /**
       * 跳转外部链接
       * 罗锦炜
       * 2021-12-08
       * */
      JupmOtherPath(id) {
        if (id == 1) {
          console.log('1');
        } else if (id == 2) {
          window.open('http://www.innohebei.net/index', "_blank"); // 打开新的窗口
        } else if (id == 3) {
          console.log('3');
        } else if (id == 4) {
          console.log('4');
        }
      }
    },
  };
</script>
<style type="text/css">
  .sizeColor {
    color: #2E67B1 !important;
  }

  * {
    padding: 0;
    margin: 0;
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }

  /* 	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n+1) {
		background-color: #d3dce6;
	} */

  img {
    width: 100%;
    height: 100%;
  }
</style>
<style lang="less">
  .headerTopqie {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .websiteIconBtn1 {
    .elButt {
      // display: flex;
      background: #2e67b1;
      border-radius: 20px;
      padding: 7px 17px;
      box-sizing: border-box;
      border: none;
    }
  }

  @z: 0.5px;

  .websiteIconBtn {
    margin-left: 10px;
    margin-top: 20px;
    margin-bottom: 50px;
    text-align: left;

    .elButt {
      // display: flex;
      background: #2e67b1;
      border-radius: 20px;
      padding: 7px 17px;
      box-sizing: border-box;
      border: none;

      .iconIMg {
        width: 24px;
        height: 24px;
        // background: orange;
        border-radius: 20px;
        margin-right: 10px;
      }

      &>span {
        display: flex;
        //   align-items: center;
        // background: red;
      }
    }
  }

  .RussiaWeb {
    width: 8.125rem;
    height: 2.1875rem;
    background: #2E67B1;
    border-radius: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 2.5rem;

    .RussiaWebImg {
      width: 1.0625rem;
      height: 1.0625rem;
      margin-right: 0.53125rem;
    }

    .RussiaWebText {
      font-size: 0.875rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
    }
  }

  .noIndexPageImg {
    width: 100%;
    // height:480px;
    position: relative;

    // background: red;
    .noIndexShow {
      width: 100%;
      height: 100%;
      position: relative;

      // background: orange;
      img {
        width: 100%;
        height: 100%;
      }

      .black_div {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.2);
        position: absolute;
        top: 0;
        left: 0;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;

        &>span>div {
          font-size: 1.1rem;
          font-family: Microsoft YaHei;
          font-weight: bold;

          &>span {
            font-size: 1.1rem;
            font-family: Microsoft YaHei;
            font-weight: 500;
          }
        }
      }
    }

  }


  #el-drawer__title {
    height: 75px;
    margin-bottom: 72 * @z;
    background-image: url(../assets/header/backMenu.png);
    background-size: 100% 100%;
    justify-content: space-between;
    align-items: center;
    padding: 0px 20px 0;
    z-index: 99 !important;

    img {
      width: 245.8 * @z;
      height: 79 * @z;
      padding-left: 0.5rem;
    }

    &>.el-drawer__close-btn {
      .el-dialog__close {
        color: #FFF;
        z-index: 99 !important;
      }
    }
  }

  .el-drawer__header>:first-child {
    flex: none !important;
  }

  .drawerCon {
    padding: 0px 20px 0;
    // height: 500px;

    .drawerConTitle1 {

      // 菜单内容框
      .drawerConTitle2 {
        // 没有折叠面板的菜单内容
        width: 97%;
        height: 45px;
        border-bottom: 1px solid #CCC;
        padding-left: 8px;
        font-size: 15px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        display: flex;
        align-items: center;
      }

      .drawerConTitle3 {

        // 折叠面板的菜单内容样式
        .wai {
          //外部折叠面板内容父级
          width: 100%;
          // height: 47px;
          border: none;

          .waiCon {

            //外部折叠面板
            &>div:nth-child(1) {

              // border-bottom: 1px solid #CCC;
              .el-collapse-item__header {
                //外部折叠面板按钮(文字)样式
                padding-left: 8px;
                background-color: none;
                font-size: 15px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #333333;
                border-bottom: 1px solid #ccc;

              }
            }

            .el-collapse-item__wrap {
              border-bottom: 1px solid #ccc;
              // padding-left: 20px;
            }
          }
        }

        .nei {
          border: none;
          border-bottom: 1px solid #ccc;
          width: 95%;
          margin-left: 5%;

          .neiCon {
            width: 100%;

            &>div:nth-child(1) {
              border-bottom: 1px solid #CCC;

              .el-collapse-item__header {
                border: none;
                background-color: none;
                margin-left: 8px;
                font-size: 0.875rem;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #666666;
              }

              .el-collapse-item__wrap {
                padding-left: none;

                .el-collapse-item__content {
                  padding: 10px 0;
                }
              }
            }



            .el-collapse-item__wrap {
              padding-left: none !important;

              .el-collapse-item__content {
                padding: 10px 0;
              }
            }
          }



          .neiConLink {
            text-align: left;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-wrap: wrap;
            margin-left: 1.25rem;

            &>div {
              margin: 0.1rem 0;
            }
          }
        }



      }

    }
  }


  .navBg {
    background-color: #FFF;
  }

  .headerTop {
    width: 100%;
    position: fixed;
    top: 0px;
    z-index: 50;
    display: flex;
    justify-content: space-between;
    align-items: center;

    // background-color: #FFF;
    .headerTopImg1 {
      width: 85px;
      height: 54 *@z;
    }

    .headerTopDiv {
      width: 2.5rem;
      height: 2.5rem;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .headerTopImg2 {
      width: 38 *@z;
      height: 32 *@z;
    }
  }

  .headerBanner {
    .el-carousel__container {
      .el-carousel__arrow {
        background-color: rgba(00, 00, 00, .4);
      }

      .el-carousel__arrow--left {
        left: 10px;
      }

      .el-carousel__arrow--right {
        right: 10px;
      }
    }

    // margin-bottom: 30 * @z;
    z-index: 1;

    .el-carousel__indicators {
      .el-carousel__indicator {
        .el-carousel__button {
          height: 0.25rem;
          border-radius: 0.3125rem;
        }
      }
    }
  }

  .bannerCons {
    width: 100%;
    // height: 332px * @z;
    margin-bottom: 61 * @z;
    // margin-top: 30 * @z;

    &>.el-carousel {
      &>.el-carousel__container {
        height: 100%;

      }
    }

    img {
      border-radius: 3px;
    }

    .showCon {
      width: 91.334%;
      margin-bottom: 20 * @z;
      padding: 0 32 * @z;
      padding-top: 30 * @z;

      .showConTop {
        width: 100%;
        display: flex;
        justify-content: space-around;
        margin-bottom: 10px;

        .showConTopImg {
          width: 100%;
          height: 156 * @z;
        }
      }

      .showConbBtton {
        width: 100%;
        display: flex;
        justify-content: space-around;

        .showConTopImg {
          width: 100%;
          height: 156 * @z;

          img {
            height: 78px;
          }

          .el-col {
            padding-left: 5px !important;
            padding-right: 5px !important;
          }

          .el-col-21 {
            width: 85% !important;
          }
        }
      }
    }

    .showCon_2 {
      width: 91.334%;
      margin-bottom: 20 * @z;
      padding: 0 32 * @z;
      margin-top: 30 * @z;

      .showCon2Top {
        width: 100%;
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        margin-bottom: 10px;

        .showCon2TopImg {
          // width: 47%;
          display: flex;
          flex-wrap: wrap;
          height: 156 * @z;
          margin-bottom: 10px;
        }
      }
    }

    .showCon_3 {
      width: 91.334%;
      margin-bottom: 20 * @z;
      padding: 0 32 * @z;
      margin-top: 30 * @z;

      .showCon3Top {
        width: 100%;
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        margin-bottom: 10px;

        .showCon3TopImg {
          width: 31%;
          display: flex;
          flex-wrap: wrap;
          height: 156 * @z;
          margin-bottom: 10px;
        }
      }
    }
  }
</style>